
import type { PropType } from 'vue'
import type { InstanceManagementMessages } from '../../models/i18n/instance-management/instance-management.messages'

import { computed, defineComponent, ref } from 'vue'

import { UiModal } from '../keen-ui'
import { EpbButton } from '../shared/epb-button'
import EpbTextbox from '../shared/epb-textbox/epb-textbox.component.vue'

export default defineComponent({
  name: 'NewInstanceModal',
  components: {
    UiModal,
    EpbTextbox,
    EpbButton,
  },
  props: {
    messages: {
      type: Object as PropType<InstanceManagementMessages['requestNewInstance']>,
      required: true,
    },
  },
  emits: {
    save: (value: string) => {},
  },
  setup(props, { emit }) {
    const baseClass = 'epb-new-instance-modal'

    const modal = ref()
    const newInstanceName = ref('')

    const valid = computed<boolean>(() => {
      const value = newInstanceName.value.trim()
      return !!value && /^[a-z0-9ñ-]+$/i.test(value)
    })

    const open = (): void => {
      newInstanceName.value = ''
      modal.value.open()
    }

    const close = (): void => {
      modal.value.close()
    }

    const save = (): void => {
      emit('save', newInstanceName.value)
    }

    return {
      baseClass,
      valid,
      modal,
      newInstanceName,
      open,
      close,
      save,
    }
  },
})
